import { List } from '@kerfjs/ui/list';
import { Row } from '@kerfjs/ui/row';
import { type SafeHtml } from 'kerfjs';

import { DecidedBadges } from './decided-badges.js';
import { Outcomes } from './outcomes.js';
import { summaryContext } from './summary-context.js';

/** The purchase Outcomes pane: per-line final price + vendor, and realized savings. */
export function OutcomesPane(): SafeHtml {
  const { lines, current, decidedCount, allDecided, base } = summaryContext();
  return (
    <List className="outcomes-pane" gap="l">
      <Row vAlign="middle" gap="xs" wrap controlInsets="rl">
        <DecidedBadges decidedCount={decidedCount} total={lines.length} allDecided={allDecided} />
      </Row>
      <Outcomes lines={lines} current={current} base={base} />
    </List>
  );
}
